export const PROCESSOR_NEWTEK = '0';
export const PROCESSOR_PSP = '1';
export const PROCESSOR_SVS = '2';
export const PROCESSOR_TCC = '3';
export const PROCESSOR_FDC = '4';
export const PROCESSOR_CHC = '5';
export const PROCESSOR_PTN = '6';
export const PROCESSOR_PSP_SNAP = '7';
export const PROCESSOR_PAYPAL = '8';

export const PROCESSOR_NAMES = {
  [PROCESSOR_NEWTEK]: 'NewTek',
  [PROCESSOR_PSP]: 'PSP',
  [PROCESSOR_SVS]: 'SVS',
  [PROCESSOR_TCC]: 'TCC',
  [PROCESSOR_CHC]: 'CHC',
  [PROCESSOR_PTN]: 'Paytronix',
  [PROCESSOR_PSP_SNAP]: 'PSP_SNAP',
  [PROCESSOR_PAYPAL]: 'PayPal'
};

export const PROCESSORS = {
  NTK: PROCESSOR_NEWTEK,
  PSP: PROCESSOR_PSP,
  SVS: PROCESSOR_SVS,
  TCC: PROCESSOR_TCC,
  FDC: PROCESSOR_FDC,
  CHC: PROCESSOR_CHC,
  PTN: PROCESSOR_PTN,
  PSP_SNAP: PROCESSOR_PSP_SNAP
};

export const PROCESSORS_ACH = [PROCESSOR_CHC];

export const FDC_PARTIAL_AUTHORIZATION_APPROVAL_CAPABILITY_DEFAULT = '0';
export const FDC_LEVEL2_DEFAULT = true;
export const FDC_PO_NUMBER_TYPE_CUSTOM = '';
export const FDC_PO_NUMBER_TYPE_LASTFOUR = 'lastfour';
export const FDC_PO_NUMBER_TYPES = [FDC_PO_NUMBER_TYPE_CUSTOM, FDC_PO_NUMBER_TYPE_LASTFOUR];

export const FDC_L2_GROUP_TAX_AMOUNT_DEFAULT = '4';

export const FDC_L3_GROUP_ITEM_CODE_DEFAULT = 'ComCode123';
export const FDC_L3_GROUP_ITEM_DESC_DEFAULT = 'description1';
export const FDC_L3_GROUP_QUANTITY_DEFAULT = '1';
export const FDC_L3_GROUP_UNIT_OF_MEASURE_DEFAULT = 'EAC';
export const FDC_L3_GROUP_UNIT_COST_DEFAULT = '1';
export const FDC_L3_GROUP_ITEM_TOTAL_DEFAULT = '1';

export const CROSS_PROCESSOR_MAP = {
  [PROCESSOR_NEWTEK]: PROCESSOR_FDC,
  [PROCESSOR_PSP]: PROCESSOR_PSP,
  [PROCESSOR_FDC]: PROCESSOR_FDC
};

export default {
  PROCESSOR_NEWTEK,
  PROCESSOR_PSP,
  PROCESSOR_SVS,
  PROCESSOR_TCC,
  PROCESSOR_PTN,
  PROCESSOR_FDC,
  PROCESSOR_NAMES,
  PROCESSORS,
  CROSS_PROCESSOR_MAP,
  FDC_PARTIAL_AUTHORIZATION_APPROVAL_CAPABILITY_DEFAULT,
  FDC_LEVEL2_DEFAULT,
  FDC_PO_NUMBER_TYPE_CUSTOM,
  FDC_PO_NUMBER_TYPE_LASTFOUR,
  FDC_PO_NUMBER_TYPES,
  FDC_L2_GROUP_TAX_AMOUNT_DEFAULT,
  FDC_L3_GROUP_ITEM_CODE_DEFAULT,
  FDC_L3_GROUP_ITEM_DESC_DEFAULT,
  FDC_L3_GROUP_QUANTITY_DEFAULT,
  FDC_L3_GROUP_UNIT_OF_MEASURE_DEFAULT,
  FDC_L3_GROUP_UNIT_COST_DEFAULT,
  FDC_L3_GROUP_ITEM_TOTAL_DEFAULT,
  PROCESSORS_ACH,
  PROCESSOR_PAYPAL
};
